import axios from 'axios'
import { apiBaseUrl } from '@/variables/localVariables'
import store from '@/store/store'


export class APIContent {

  getContents(page, contentType=null, categories=null, search=null, userId=null, contentId=null, withNotPublished=null, onlyLiked=null) {
    let url = `${apiBaseUrl}/contents/?page=${page}`

    if (contentType) {
      url = url + `&contentType=${contentType}`
    }

    if (categories) {
      url = url + `&categories=${categories.join(',')}`
    }

    if (search) {
      url = url + `&search=${search}`
    }

    if (userId) {
      url = url + `&userId=${userId}`
    }

    if (contentId) {
      url = url + `&contentId=${contentId}`
    }

    if (withNotPublished) {
      url = url + `&withNotPublished=${withNotPublished}`
    }

    if (onlyLiked) {
      url = url + `&onlyLiked=${onlyLiked}`
    }

    const headers = {
      'Content-Type': 'application/json',
    }

    return axios.get(url, { headers })
  }

  getContent(id) {
    const url = `${apiBaseUrl}/contents/${id}/`

    const token = JSON.parse(store.state.auth.token).access

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    return axios.get(url, { headers })
  }

  likeContent(contentId) {
    const url = `${apiBaseUrl}/contents/${contentId}/likes/`

    const token = JSON.parse(store.state.auth.token).access

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    return axios.put(url, {}, { headers })
  }

  confirmPayContent(contentId) {
    const url = `${apiBaseUrl}/contents/${contentId}/pay-content/`

    const token = JSON.parse(store.state.auth.token).access

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    return axios.post(url, {}, { headers })
  }
}
